export const colors = {
    red: '#FF5253',
    white: '#FFFFFF',
    gray: '#4F4F4F',
    black: '#000000'
}